import * as endpoints from "../configs/endpoints";
import * as types from "../constants/actionTypes";
import { GET_METHOD, POST_METHOD } from "../constants/apiMethods";

export const sendNotification = (payload) => ({
  endpoint: endpoints.sendNotification(),
  method: POST_METHOD,
  types: [
    types.SEND_NOTIFICATION_REQUEST,
    types.SEND_NOTIFICATION_SUCCESS,
    types.SEND_NOTIFICATION_FAILURE,
  ],
  body: payload,
});

export const getSegments = () => ({
  endpoint: endpoints.getSegments(),
  method: GET_METHOD,
  types: [
    types.GET_SEGMENTS_REQUEST,
    types.GET_SEGMENTS_SUCCESS,
    types.GET_SEGMENTS_FAILURE,
  ],
});

export const getNotificationHistory = (params) => ({
  endpoint: endpoints.getNotificationHistory(),
  method: GET_METHOD,
  types: [
    types.GET_NOTIFICATION_HISTORY_REQUEST,
    types.GET_NOTIFICATION_HISTORY_SUCCESS,
    types.GET_NOTIFICATION_HISTORY_FAILURE,
  ],
  params,
});

export const clearNotificationState = () => ({
  type: types.CLEAR_NOTIFICATION_STATE,
});

export const getBroadcastQuota = () => ({
  endpoint: endpoints.getBroadcastQuota(),
  method: GET_METHOD,
  types: [
    types.GET_BROADCAST_QUOTA_REQUEST,
    types.GET_BROADCAST_QUOTA_SUCCESS,
    types.GET_BROADCAST_QUOTA_FAILURE,
  ],
});

export const estimateRecipients = (payload) => ({
  endpoint: endpoints.estimateNotificationRecipients(),
  method: POST_METHOD,
  types: [
    types.ESTIMATE_RECIPIENTS_REQUEST,
    types.ESTIMATE_RECIPIENTS_SUCCESS,
    types.ESTIMATE_RECIPIENTS_FAILURE,
  ],
  body: payload,
});

export const clearEstimatedRecipients = () => ({
  type: types.CLEAR_ESTIMATED_RECIPIENTS,
});

export const cancelNotification = (notificationId) => ({
  endpoint: endpoints.cancelNotification(),
  method: POST_METHOD,
  types: [
    types.CANCEL_NOTIFICATION_REQUEST,
    types.CANCEL_NOTIFICATION_SUCCESS,
    types.CANCEL_NOTIFICATION_FAILURE,
  ],
  body: { notification_id: notificationId },
});
